export function getUserInfo(config) {
  const userId =
    config?.metadata?.username ||
    config?.params?.username ||
    config?.data?.username ||
    config?.headers?.username ||
    "Pago-En-Linea-Generico";

  return {
    userId,
    userAgent:
      (typeof navigator !== "undefined" && navigator.userAgent) || "Unknown",
  };
}

export function getUsernameFromSessionStorage() {
  if (typeof window !== "undefined") {
    return (
      sessionStorage.getItem("username") ||
      sessionStorage.getItem("userName") ||
      sessionStorage.getItem("user") ||
      null
    );
  }
  return null;
}
